module.exports = __parcel__import__.meta.resolve("6n6EE");